<template>
  <el-collapse v-model="activeNames" class="timeline-collapse">
    <el-collapse-item name="1" class="timeline-collapse-item">
      <template slot="title">
        <div class="timeline-header">
          <div class="timeline-header-left">
            <i class="el-icon-time timeline-icon"></i>
            <span class="timeline-title">Historial de cotización</span>
          </div>
          <span v-if="events.length" class="timeline-count">{{
            events.length
          }}</span>
        </div>
      </template>

      <div v-if="loading" class="timeline-loading">
        <i class="el-icon-loading"></i> Cargando...
      </div>

      <div v-else-if="events.length === 0" class="timeline-empty">
        Sin eventos registrados.
      </div>

      <div v-else class="timeline-list">
        <div
          v-for="(event, index) in events"
          :key="index"
          class="timeline-item"
          :class="`timeline-item--${event.type}`"
        >
          <div class="timeline-dot">
            <i :class="['timeline-dot-icon', iconFor(event.type)]"></i>
          </div>
          <div class="timeline-content">
            <div class="timeline-label">{{ event.label }}</div>
            <div class="timeline-at">{{ formatDate(event.at) }}</div>
            <div v-if="event.meta && event.meta.email" class="timeline-meta">
              Enviado a: {{ event.meta.email }}
              <span v-if="event.meta.version" class="timeline-meta-tag"
                >v{{ event.meta.version }}</span
              >
            </div>
            <div v-if="event.meta && event.meta.subject" class="timeline-meta">
              {{ event.meta.subject }}
            </div>
            <div v-if="event.meta && event.meta.reason" class="timeline-meta">
              Motivo: {{ event.meta.reason }}
            </div>
            <div
              v-if="event.meta && event.meta.invoice_number"
              class="timeline-meta"
            >
              Factura
              <strong>#{{ event.meta.invoice_number }}</strong>
            </div>
          </div>
        </div>
      </div>
    </el-collapse-item>
  </el-collapse>
</template>

<script>
import quoteService from "../services/quoteService";

export default {
  name: "QuoteTimeline",
  props: {
    quoteId: { type: Number, required: true }
  },
  data() {
    return {
      activeNames: [],
      loading: false,
      events: []
    };
  },
  watch: {
    activeNames(val) {
      if (val.includes("1") && this.events.length === 0) {
        this.load();
      }
    }
  },
  methods: {
    async load() {
      this.loading = true;
      try {
        const res = await quoteService.getTimeline(this.quoteId);
        this.events = res.data.data || [];
      } catch {
        this.events = [];
      } finally {
        this.loading = false;
      }
    },
    iconFor(type) {
      const icons = {
        created: "el-icon-document",
        edited: "el-icon-edit",
        sent: "el-icon-s-promotion",
        reminder: "el-icon-bell",
        received: "el-icon-message",
        preapproved: "el-icon-check",
        approved: "el-icon-circle-check",
        rejected: "el-icon-circle-close",
        converted: "el-icon-document-checked"
      };
      return icons[type] || "el-icon-more";
    },
    formatDate(iso) {
      if (!iso) return "";
      const d = new Date(iso);
      return d.toLocaleDateString("es-EC", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit"
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.timeline-collapse {
  border: none;
  width: 100%;
}

.timeline-collapse-item {
  background: #fff;
  border-radius: 12px !important;
  border: 1px solid #e8ecf2;
  padding: 4px 8px;
  margin: 0;
  overflow: hidden;
  width: 100%;
}

// Remueve el border-bottom interno por defecto de el-collapse-item
.timeline-collapse-item ::v-deep .el-collapse-item__header,
.timeline-collapse-item ::v-deep .el-collapse-item__wrap {
  border-bottom: none !important;
}

.timeline-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding-right: 8px;
}

.timeline-header-left {
  display: flex;
  align-items: center;
  gap: 10px;
}

.timeline-icon {
  font-size: 16px;
  color: #3fdbbf;
}

.timeline-title {
  font-size: 14px;
  font-weight: 600;
  color: #31355c;
}

.timeline-count {
  background: #eef1f7;
  color: #31355c;
  font-size: 11px;
  font-weight: 700;
  width: 24px;
  height: 24px;
  line-height: 24px;
  border-radius: 50%;
  text-align: center;
  flex-shrink: 0;
}

.timeline-loading,
.timeline-empty {
  padding: 16px;
  font-size: 13px;
  color: #aaa;
  text-align: center;
}

.timeline-list {
  padding: 8px 4px;
  position: relative;

  &::before {
    content: "";
    position: absolute;
    left: 19px;
    top: 0;
    bottom: 0;
    width: 2px;
    background: #e8ecf2;
  }
}

.timeline-item {
  display: flex;
  gap: 12px;
  padding: 10px 8px;
  border-radius: 8px;
  transition: background 0.15s;
  position: relative;

  &:hover {
    background: #f7f8fb;
  }
}

.timeline-dot {
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  background: #fff;
  border: 2px solid #e8ecf2;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  z-index: 1;
}

.timeline-dot-icon {
  font-size: 14px;
  color: #9ca3af;
  line-height: 1;
}

.timeline-item--approved .timeline-dot,
.timeline-item--converted .timeline-dot {
  border-color: #1d9e75;
  background: #f0fdf9;
}
.timeline-item--approved .timeline-dot-icon,
.timeline-item--converted .timeline-dot-icon {
  color: #1d9e75;
}

.timeline-item--preapproved .timeline-dot {
  border-color: #534ab7;
  background: #ece8ff;
}
.timeline-item--preapproved .timeline-dot-icon {
  color: #534ab7;
}

.timeline-item--rejected .timeline-dot {
  border-color: #e24b4a;
  background: #fff0f0;
}
.timeline-item--rejected .timeline-dot-icon {
  color: #e24b4a;
}

.timeline-item--sent .timeline-dot-icon,
.timeline-item--received .timeline-dot-icon {
  color: #3fdbbf;
}

.timeline-content {
  flex: 1;
  min-width: 0;
}

.timeline-label {
  font-size: 13px;
  font-weight: 600;
  color: #31355c;
  margin-bottom: 2px;
}

.timeline-at {
  font-size: 12px;
  color: #9ca3af;
}

.timeline-meta {
  font-size: 12px;
  color: #666;
  margin-top: 2px;
}

.timeline-meta-tag {
  display: inline-block;
  background: #eef1f7;
  color: #534ab7;
  font-size: 10px;
  font-weight: 700;
  padding: 1px 6px;
  border-radius: 6px;
  margin-left: 4px;
}
</style>
